<template>
    <div class="papsi-wrapper">
        <h1 class="text-2xl font-semibold text-[#24723b]">Satellite Office Signatories for All Request Forms</h1>
        <p class="text-xs text-[#747474] mt-2">Home / Form Signatories</p>
        
    </div>
    <div class="">
        <select class="col-span-2 border-[#ACA9A9] border rounded-md py-3 text-sm text-[#12760A] font-semibold mt-3 w-full px-5" v-model="signatoryType">
            <option value="1" selected >LEAVE SIGNATORY</option>
            <option value="2" >CONSIDERATION SIGNATORY</option>
            <option value="3" >TRAINING REQUISTION SIGNATORY</option>
            <option value="4" >OVERTIME SIGNATORY</option>
            <option value="5" >OFFICIAL BUSINESS REQUEST SIGNATORY</option>
        </select>
    </div>
    <div  class="flex flex-col gap-1 mt-3 bg-[#f0f0f0] border-[#ffffff41] border-[3px] p-3 rounded-md shadow">
        <div   v-for="(data, index) in $store.state.branch" :key="index" >
            <div class=" w-full border flex gap-5 text-left py-2 px-4 font-semibold rounded-md items-center justify-between hover:bg-[#e6e6e6]">
                <span class="flex justify-start text-sm text-[#606060]">{{ data.br_desc }}</span>
                <div class="flex items-center gap-10">
                    <button class="bg-[#016B00] rounded-md py-2 px-11 text-xs text-white"  @click="setSignatory(data.br_code ,data.br_desc)">Signatory</button>
                </div>
            </div>
        </div>
    </div>
    
    <div v-if="SignatoryModal">
        <PsoSignatory :signatoryType="signatoryType"  
            :signatoryTitle="signatoryTitle" 
            :getName="GetName"
            :br_code="branch_code"
            :getBranchName="ActiveBranch"  
            @CloseSignatory="SignatoryModal= false"/>
    </div>
</template>

<script>
import { defineComponent } from "vue";
//import Services from "../../../services/admin"
import PsoSignatory from "../../controls/modal/PsoSignatoryModal.vue"

export default defineComponent({
    components:{
        PsoSignatory
    },
    data(){
        return{
            signatoryType: '1',
            SignatoryModal: false,
            branch_code:'',
            ActiveBranch: "",
        }
    },
    mounted(){

    },
    methods:{
        setSignatory(br_code,br_desc){
            this.ActiveBranch = br_desc
            this.branch_code = br_code
            this.SignatoryModal = true
        }
    },
})


</script>


<style scoped>
.active{
    background-color: #24723b;
    color: beige;
}

.activeSection{
    background-color: #CDAF13;
    color: beige;
}
.spanactive{
    color: white;
}
</style>